export default __webpack_public_path__ + "static/media/anhphong.e2ab36f2.jpg";